import { render } from "./CartOffersTab.vue?vue&type=template&id=283ca9d3"
import script from "./CartOffersTab.vue?vue&type=script&lang=js"
export * from "./CartOffersTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__